module.exports = __webpack_public_path__ + "7924602332033323982467cba7414924.pdf";